export type InputSchema = (InputSchemaLeaf | InputSchemaBranch)[];
export type InputSchemaLeaf = string;
export type InputSchemaBranch = { name: string; schema: InputSchema };

export const filterObjByArray = <T extends Record<string, any>>(
  schema: InputSchema,
  vars: T
): T =>
  schema.reduce((result, k) => {
    let key: string;
    let value: any;
    if (typeof k === 'string') {
      key = k;
      value = vars[k];
      if (value === undefined) return result;
    } else {
      key = k.name;
      value =
        vars[key] instanceof Array
          ? vars[key].map((item: any) => filterObjByArray(k.schema, item))
          : vars[key] === null || vars[key] === undefined
            ? vars[key]
            : filterObjByArray(k.schema, vars[key]);
    }
    return {
      ...result,
      [key]: value,
    };
  }, {} as T);
